/**
 * Chart.js globals
 */
var VKChartGlobalSettings = {
    langCode: 'fi'
}
/**
 * Helper functions
 */

function extendObjects(obj, src) {
    for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
    }
    return obj;
}

function formatNumberInUI(number) {
    if(VKChartGlobalSettings.langCode == 'fi' || VKChartGlobalSettings.langCode == 'sv')
        number = number.replace(".",",");
    return number;
}

function chartLegendCallBack(chart) {
    var legendHtml = [];
    legendHtml.push('<ul>');
    var chartItem = chart.data.datasets[0];

    for (var i=0; i < chartItem.data.length; i++) {
        var unit = '';
        if(typeof chartItem.dataUnit !== 'undefined') {
            unit = typeof chartItem.dataUnit[i] !== 'undefined' ? chartItem.dataUnit[i] : '';
        }
        legendHtml.push('<li>');
        legendHtml.push('<span class="chart-legend--label-color" style="background-color:' + chartItem.backgroundColor[i] +'"></span>');
        legendHtml.push('<span class="chart-legend--label-text"><strong>'+formatNumberInUI(chartItem.data[i])+' ' + unit + '</strong><br>' + chart.data.labels[i]+'</span>');
        legendHtml.push('</li>');
    }

    legendHtml.push('</ul>');
    return legendHtml.join("");
}

 /**
  * Initialize chart
  */
jQuery(document).ready(function() {

    //initialized chart objects
    var CHARTS = [];
    var debug = false;
    

    if(debug)
        console.log('Starting load charts..');
    
    if(typeof document.documentElement.lang !== 'undefined') {
        VKChartGlobalSettings.langCode = document.documentElement.lang;
    }

    //one page can contain multiple charts
    var chartContainer = document.querySelectorAll(".chart-canvas");
    
    //chartContainer.forEach(function(element) {
    for (i = 0; i < chartContainer.length; i++) {
        var element = chartContainer[i];
        
        var data = JSON.parse(element.innerHTML);
        var chartStyle = element.getAttribute('data-style') ? element.getAttribute('data-style') : 'bar';
        var skin = element.getAttribute('data-skin') ? element.getAttribute('data-skin') : 'default';

        if(debug)
            console.log("Rendering chart: ", data);

        Chart.helpers.merge(Chart.defaults.global, {
            layout: {
                padding: {
                    top: 20
                }
            }
        });

        var colors = {
            default: {
                text: '#111111',
                textHighlight: '#111111',
                textLight: '#999999',
                accent: '#10497F',
                legendText: '#111111'
            },
            light: {
                text: '#ffffff',
                textHighlight: '#ffffff',
                textLight: '#ffffff',
                accent: '#ffffff',
                legendText: '#ffffff'
            },
            monolime: {
                text: '#ffffff',
                textHighlight: '#ffffff',
                textLight: '#ffffff',
                accent: '#d6e342',
                legendText: '#ffffff'
            }
        };

        //Base configuration for all charts
        var baseConfiguration = {
            type: chartStyle,
            data: {
                labels: data.labels,
                datasets: [{
                    label: "",
                    data: data.values,
                    dataUnit: data.value_unit,
                    backgroundColor: data.colors,
                    borderWidth: 0,
                    datalabels:{
                        color: '#666767'
                    }
                }]
            },
            options: {
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                // maintainAspectRatio: false,
                legend: false,
                legendCallback: chartLegendCallBack
            }
        };
        var barTicks  = {
            display: false,
        }
        var barGridlines = {
                display:false,
                drawBorder: false,
                lineWidth: 0,
                offsetGridLines: true,
                drawTicks: false,
                zeroLineWidth: 0,
                zeroLineColor: '#ffffff'
        }
        var barDrawBorder = true;

        //if (data.beginAtZero == 1){
            barTicks  = {
                display: true,
                padding: 0,
                beginAtZero: true,
                fontColor: "transparent"
            }
            barGridlines = {
                display:true,
                drawBorder: false,
                lineWidth: 0,
                offsetGridLines: false,
                drawTicks: true,
                zeroLineWidth: 2,
                zeroLineColor: data.colors[0],
                color: '#FFFFFF'
            }
            barDrawBorder = false;
        //}

        //chart style based configuration
        var chartStyleConfiguration = {
            pie: {

            },
            doughnut: {
                options:{
                    responsive: true,
                    cutoutPercentage: 85,
                    //legend: false,
                    /*legend:{
                        position: 'bottom',

                        labels: {
                            fontColor: colors[skin].legendText
                        }
                    }*/
                    legend: false,
                    legendCallback: chartLegendCallBack,
                    plugins: {
                        datalabels: {
                            display: false,
                        }
                    }
                }
            },
            bar: {
                borderWidth: 0,
                options: {
                    plugins: {
                        datalabels: {
                            anchor: 'end',
                            align: 'end',
                            color: colors[skin].textLight
                        }
                    },
                    //maintainAspectRatio: false,
                    legend: false,
                    legendCallback: chartLegendCallBack,
                    scales: {
                        xAxes: [{
                            barPercentage: 0.4,
                            gridLines: {
                                display:false,
                                lineWidth: 0,
                                offsetGridLines: true,
                                drawTicks: false,
                                drawBorder: barDrawBorder,
                                zeroLineWidth: 6,
                                //zeroLineColor: colors[skin].accent
                                zeroLineColor: '#d6e342'
                            },
                            ticks: {
                                fontSize: 14,
                                fontFamily: 'Roboto',
                                fontColor: colors[skin].textHighlight,
                                fontStyle: 'bold',
                                padding: 10
                            }
                        }],
                        yAxes: [{
                            //barPercentage: 0.4,
                            gridLines: barGridlines,
                            ticks: barTicks
                        }]
                    }
                }
            }
        };

        configuration = extendObjects(baseConfiguration, chartStyleConfiguration[chartStyle]);
        var chart = new Chart(element, configuration);

        if(debug)
            console.log("Configuration", configuration);

        var legendElement = document.getElementById(element.getAttribute('data-legend-id'));
		if(legendElement)
            legendElement.innerHTML = chart.generateLegend();

        element.innerHTML = '';
        element.classList.remove('hide');

        CHARTS.push(chart);
    //});
    }


    // Sticky tabs
    if( jQuery('.header-graph').length > 0 ){
        if( jQuery('.tabs-wrapper').length > 0){
            var tabsTopPosition = jQuery('.tabs-wrapper').offset().top;
            var tabsHeight = jQuery('.tabs-wrapper').height();
        }

        jQuery(window).scroll(function() {
            // Tabs
            if ( jQuery(window).scrollTop() > tabsTopPosition ) {
                jQuery('.tabs-wrapper').addClass('sticky');
                jQuery('.service main').css('padding-top', tabsHeight);
            } else {
                jQuery('.tabs-wrapper').removeClass('sticky');
                jQuery('.service main').css('padding-top', '0');
            }
        });
    }
});
